import { render, staticRenderFns } from "./zijian_03.vue?vue&type=template&id=0d8f9ff3&scoped=true&"
import script from "./zijian_03.vue?vue&type=script&lang=js&"
export * from "./zijian_03.vue?vue&type=script&lang=js&"
import style0 from "./zijian_03.vue?vue&type=style&index=0&id=0d8f9ff3&prod&lang=less&"
import style1 from "./zijian_03.vue?vue&type=style&index=1&id=0d8f9ff3&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f9ff3",
  null
  
)

export default component.exports